import * as z from 'zod';

import { addressQuerySchema } from '@/_containers/inputs/address/shared';
import { emergencyContactQuerySchema } from '@/_containers/inputs/emergency-contact/schemas';
import { preferredRelationsShipsQuerySchema } from '@/_pages/settings/preferred-relationships/shared';
import { fileQuerySchema } from '@/_schemas/file';
import { nullableNumericQuerySchema, paginatedResponseSchema } from '@/_schemas/generic';
import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';
import { statusQuerySchema } from '@/_schemas/status-input';
import { teamMemberQueryLinkerSchema } from '@/_schemas/team-members/team-members-query-linker-schema';

import { commissionPeriodsQuerySchema } from './commission-periods-schema';

import { genderQuerySchema } from '../../../../_containers/inputs/gender';
import { shirtSizePreferenceQuerySchema, techPreferenceQuerySchema } from '../components';

const teamMemberBaseQuerySchema = z.object({
  ...teamMemberQueryLinkerSchema.shape,
  job_title: z.string().nullable(),
  status: statusQuerySchema,

  gender: genderQuerySchema.nullable(),
  tech_preference: techPreferenceQuerySchema.nullable(),
  t_shirt_size: shirtSizePreferenceQuerySchema.nullable(),

  personal_email: z.string().nullable(),
  work_email: z.string().nullable(),
  hr_identifier: z.string().nullable(),
  internal_extension: z.string().nullable(),
  // display_name: z.string().nullable(),

  hired_on: z.string().nullable(),
  pet_names: z.string().nullable(),
  birthdate: z.string().nullable(),
  termination: z.string().nullable(),
  parent_id: z.number().nullable(),

  interests: z.string().nullable(),
  biography: z.string().nullable(),
  children_names: z.string().nullable(),
  spouse_name: z.string().nullable(),
  preferred_relationship_id: z.number().nullable(),
  preferred_relationship: preferredRelationsShipsQuerySchema.nullish(),
  w2_withholdings: z.number().nullable(),
  tax_type: z.string().nullable(),
  manual: z.array(fileQuerySchema).nullish(),
  addresses: z.array(addressQuerySchema).nullish(),
  phone_numbers: z.array(phoneNumberQuerySchema).nullish(),

  gusto: z.string().nullable(),
  harvest: nullableNumericQuerySchema(),
  zoom: nullableNumericQuerySchema(),
  freshdesk: nullableNumericQuerySchema(),

  /**
   * Financial Override PIN (revenue lockdown override PIN).
   * Backend may omit this field for users without permission.
   */
  lockdown_override_pin: z.string().nullish(),
  has_lockdown_override_pin: z.boolean().nullish(),
});

export const teamMemberQuerySchema = teamMemberBaseQuerySchema.extend({
  parent: teamMemberQueryLinkerSchema.nullish(),
  children: z.array(teamMemberQueryLinkerSchema).nullish(),
  emergency_contact: z.array(emergencyContactQuerySchema).nullish(),
  gallery: z.array(fileQuerySchema).nullish(),
  offer_letter: z.array(fileQuerySchema).nullish(),
  employment_agreement: z.array(fileQuerySchema).nullish(),
  handbook_acknowledgement: z.array(fileQuerySchema).nullish(),
  vector_signatured: z.array(fileQuerySchema).nullish(),
  business_card_template: z.array(fileQuerySchema).nullish(),
  commission_periods: z.array(commissionPeriodsQuerySchema).nullish(),
});

export type TeamMemberQuerySchema = z.infer<typeof teamMemberQuerySchema>;

export const teamMembersQueryAllSchema = paginatedResponseSchema(teamMemberQuerySchema);

export type TeamMembersQueryAllSchema = z.infer<typeof teamMembersQueryAllSchema>;
